/**
 * Compress an image File to JPEG, capped at maxWidth/maxHeight and maxSizeKB.
 * Returns a new File object.
 */
export async function compressImage(file, { maxWidth = 800, maxHeight = 800, maxSizeKB = 300, quality = 0.8 } = {}) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    const objectUrl = URL.createObjectURL(file)

    img.onload = () => {
      URL.revokeObjectURL(objectUrl)

      let { width, height } = img

      // Scale down to fit within maxWidth x maxHeight
      if (width > maxWidth || height > maxHeight) {
        const ratio = Math.min(maxWidth / width, maxHeight / height)
        width = Math.round(width * ratio)
        height = Math.round(height * ratio)
      }

      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height
      canvas.getContext('2d').drawImage(img, 0, 0, width, height)

      // Try reducing quality until under maxSizeKB
      let q = quality
      const tryCompress = () => {
        canvas.toBlob((blob) => {
          if (!blob) { reject(new Error('Compression failed')); return }
          if (blob.size / 1024 > maxSizeKB && q > 0.3) {
            q -= 0.1
            tryCompress()
          } else {
            resolve(new File([blob], file.name.replace(/\.[^.]+$/, '.jpg'), { type: 'image/jpeg' }))
          }
        }, 'image/jpeg', q)
      }
      tryCompress()
    }

    img.onerror = reject
    img.src = objectUrl
  })
}
